import { TranslateProvider, useTranslate } from './translations';
import { useState } from 'react';
import { useIsMobile } from './hooks/useIsMobile';
import { Alert } from './components/alert';
import { JobOffer, Application, useAdvert, getCurrentAdvertId } from './features/advert';
import { Button } from './components/button';
import classNames from 'classnames';
import styles from './App.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { AnimatedLoading } from './components/spinner';
import { ThemeSelector } from './styles/themes/ThemeSelector';
import { ErrorPage, ErrorBoundary } from './components/error';
import { Layout } from './components/layout';

const Content = ({ error }: { error?: number | null }) => {
  const translator = useTranslate();
  const [hideJobOffer, setHideJobOffer] = useState(false);
  const isMobile = useIsMobile();

  if (error === 404) {
    return <Alert color="warning">{translator('alert_not_found')}</Alert>;
  }

  if (error) {
    return <Alert color="warning">{translator('alert_load_error')}</Alert>;
  }

  return (
    <>
      {isMobile && (
        <>
          <JobOffer showDetails={false} />
          <Button color="secondary" onClick={() => setHideJobOffer(true)}>
            {translator('job_details')}
          </Button>
        </>
      )}
      <div className="card shadow pt-3">
        <div className="card-body">
          <Application />
        </div>
      </div>
      <div
        className={classNames('card shadow pt-3', styles.rightContent, {
          [styles.show]: hideJobOffer,
        })}
      >
        <div className="card-body">
          <Button className="mb-3 d-block d-md-none px-4" onClick={() => setHideJobOffer(false)}>
            <FontAwesomeIcon icon={faArrowRight} />
          </Button>
          <JobOffer />
        </div>
      </div>
    </>
  );
};

const FormApp = () => {
  const {
    template,
    isLoading,
    advert: { language },
    error,
  } = useAdvert(getCurrentAdvertId());

  if (isLoading) {
    return (
      <div style={{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <AnimatedLoading />
      </div>
    );
  }

  return (
    <TranslateProvider defaultLocale={language}>
      <ThemeSelector theme={template}>
        <ErrorBoundary fallback={<ErrorPage />}>
          <Layout className={styles.layout}>
            <Content error={error} />
          </Layout>
        </ErrorBoundary>
      </ThemeSelector>
    </TranslateProvider>
  );
};

export default FormApp;
